
/**
 * Created by libaiqi on 2019/01/17
 */
import Logic from '../logic-base'

const orderStatisticsBiz = new Logic()

orderStatisticsBiz.getOrderStatistics = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.orderSearch.getOrderStatistics,
    data: data
  })
}

export default orderStatisticsBiz
